import React, { useEffect, useState } from 'react';

export default function PaymentComplete() {
  const [status, setStatus] = useState('sending');

  useEffect(() => {
    const params      = new URLSearchParams(window.location.search);
    const vendorEmail = params.get('vendorEmail');
    const vendorName  = params.get('vendorName');
    const amount      = params.get('amount');
    const eventName   = params.get('eventName');
    const vendorId = params.get('vendorId');
    const transactionId = params.get('transactionId');
    console.log('PaymentComplete params:', { vendorId, vendorEmail, eventName, amount });

    async function sendReceipt() {
  try {
    let resolvedEventName = eventName;

    if (vendorEmail && amount) {
      const pendingRes = await fetch(`https://bioev-portal-production.up.railway.app/api/pending-payment?vendorEmail=${encodeURIComponent(vendorEmail)}&amount=${encodeURIComponent(amount)}`);
      const pendingData = await pendingRes.json();
      if (pendingData.success && pendingData.eventName) {
        resolvedEventName = pendingData.eventName;
      }
    }

    await fetch('https://bioev-portal-production.up.railway.app/api/send-receipt', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ vendorEmail, vendorName, amount, eventName: resolvedEventName, transactionId }),
    });
    setStatus('done');
  } catch (err) {
    setStatus('done');
  }
}
if (vendorEmail) {
  sendReceipt();
} else {
  setStatus('done');
}
}, []);

  return (
    <div style={{ minHeight: '100vh', background: '#040e1a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ textAlign: 'center', padding: 40, maxWidth: 480 }}>
        <div style={{ fontSize: 22, fontWeight: 700, color: '#ffffff', marginBottom: 8 }}>Bio-EV</div>
        {status === 'sending' && (
          <div style={{ fontSize: 14, color: '#5ae3a8' }}>Processing your payment confirmation...</div>
        )}
        {status === 'done' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✓</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: '#5ae3a8', marginBottom: 12 }}>Payment Received!</div>
            <div style={{ fontSize: 14, color: '#8aaa9a', lineHeight: 1.6 }}>
              Thank you for your payment. A receipt has been sent to your email address.
            </div>
          </>
        )}
      </div>
    </div>
  );
}